<template>
	<div>
		<div class="container flex-start">
			<div class="home_left_content">
				<div class="adwarp" v-if="mainAds != undefined && mainAds.length > 0" @click="pushadvertise">
					<el-carousel :interval="4000" height="210px">
						<el-carousel-item v-for="(item,index) in mainAds" :key="item.adPath" >
							<div class="advertise_bg">
								<div class="img">
									<img :src="baseUrlpath + item.adPath" />
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<!-- <div class="adwarp" @click="pushadvertise" v-else>
					<el-carousel :interval="4000" type="card" height="102px">
						<el-carousel-item v-for="item in 6" :key="item" >
							<div class="advertise_bg">
								<div class="img"></div>
								<h3 class="medium">{{ '广告位'+item }}</h3>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div> -->
				<div class="">
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.tel')}}</div>
							<div class="mrt_more" @click="goReqsByType('tel')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDatatelLoading">
							<div class="req-warp" v-if="tableDatatel.length > 0">
								<div v-for="(item,index) in tableDatatel" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.houseproperty')}}</div>
							<div class="mrt_more" @click="goReqsByType('houseproperty')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataFangLoading">
							<div class="req-warp" v-if="tableDataFang.length > 0">
								<div v-for="(item,index) in tableDataFang" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.delicacy')}}</div>
							<div class="mrt_more" @click="goReqsByType('delicacy')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDatadelicacyLoading">
							<div class="req-warp" v-if="tableDatadelicacy.length > 0">
								<div v-for="(item,index) in tableDatadelicacy" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.locomotive')}}</div>
							<div class="mrt_more" @click="goReqsByType('locomotive')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataCarLoading">
							<div class="req-warp" v-if="tableDataCar.length > 0">
								<div v-for="(item,index) in tableDataCar" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.tourist')}}</div>
							<div class="mrt_more" @click="goReqsByType('tourist')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataLyLoading">
							<div class="req-warp" v-if="tableDataLy.length > 0">
								<div v-for="(item,index) in tableDataLy" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.flightcargo')}}</div>
							<div class="mrt_more" @click="goReqsByType('flightcargo')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataHbLoading">
							<div class="req-warp" v-if="tableDataHb.length > 0">
								<div v-for="(item,index) in tableDataHb" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.markdownsale')}}</div>
							<div class="mrt_more" @click="goReqsByType('markdownsale')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataXzLoading">
							<div class="req-warp" v-if="tableDataXz.length > 0">
								<div v-for="(item,index) in tableDataXz" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.freeride')}}</div>
							<div class="mrt_more" @click="goReqsByType('freeride')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataSfcLoading">
							<div class="req-warp" v-if="tableDataSfc.length > 0">
								<div v-for="(item,index) in tableDataSfc" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.recruit')}}</div>
							<div class="mrt_more" @click="goReqsByType('recruit')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataInviteLoading">
							<div class="req-warp" v-if="tableDataInvite.length > 0">
								<div v-for="(item,index) in tableDataInvite" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.interact')}}</div>
							<div class="mrt_more" @click="goReqsByType('interact')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDatainteractLoading">
							<div class="req-warp" v-if="tableDatainteract.length > 0">
								<div v-for="(item,index) in tableDatainteract" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.discounts')}}</div>
							<div class="mrt_more" @click="goReqsByType('discounts')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDatadiscountsLoading">
							<div class="req-warp" v-if="tableDatadiscounts.length > 0">
								<div v-for="(item,index) in tableDatadiscounts" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.activity')}}</div>
							<div class="mrt_more" @click="goReqsByType('activity')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataactivityLoading">
							<div class="req-warp" v-if="tableDataactivity.length > 0">
								<div v-for="(item,index) in tableDataactivity" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>
					<div class="main_req_top">
						<div class="mrt_head">
							<div class="mrt_tit">{{$t('basic.busoppo')}}</div>
							<div class="mrt_more" @click="goReqsByType('roast')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="tableDataroastLoading">
							<div class="req-warp" v-if="tableDataroast.length > 0">
								<div v-for="(item,index) in tableDataroast" :key="item.sdr_reqId" class="req-item"
									@click="goToDetail(item)">
									<reqInfo :baseUrlpath="baseUrlpath" :item="item"></reqInfo>
								</div>
							</div>
							<div v-else class="empty-msg">
								<el-empty description="暂无内容">
									<label class="link_msg" @click="goPublish">去发布</label>
								</el-empty>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="home_right_content">
				<div>
					<!-- <div class="flex-start yjwarp sd" @click="$util.goto('proposal')">
						<div class="icon-yijian"></div>
						<div class="yjmsg">
							<div class="yj-tit">意见建议收集</div>
							<div class="yj-nail">热忱欢迎广大用户多提宝贵意见、建议</div>
						</div>
					</div> -->
					<!-- <div class="flex-column-start sd">
						<div class="rd-title">时政新闻</div>
						<div class="news-warp">
							<div class="new-item">
								<div class="new_tit">阿提哈德航空10月将开启阿布扎比-广州航线</div>
								<div class="new_time">2022-09-13</div>
							</div>
							<div class="new-item">
								<div class="new_tit">英国女王去世，阿联酋领导人发文悼念！</div>
								<div class="new_time">2022-09-09</div>
							</div>
							<div class="new-item">
								<div class="new_tit">阿拉伯航空：幸运的乘客赢得了一整年的免费</div>
								<div class="new_time">2022-08-24</div>
							</div>
							<div class="new-item">
								<div class="new_tit">广州再增1例阿联酋输入确诊病例</div>
								<div class="new_time">2022-08-05</div>
							</div>
							<div class="new-item">
								<div class="new_tit">在阿联酋如何申请和办理黄金签证？</div>
								<div class="new_time">2022-07-20</div>
							</div>
						</div>
					</div> -->
					<!-- <div class="flex-column-start sd">
						<div class="rd-title flex-between">
							<div class="flexone">{{$t('basic.correcommend')}}</div>
							<div class="mrt_more" @click="goReqsByType('/main/storeRecommendList')">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="storeCommendloading" class="hundred">
							<div v-if="storeCommendReqs.length > 0" class="comms-warp">
								<div class="comms-item" v-for="(item,index) in storeCommendReqs" :key="item.sdr_reqId">
									<storeCommendReq :baseUrlpath="baseUrlpath" :item="item"></storeCommendReq>
								</div>
							</div>
							<div v-else class="recomm-empty-msg">
								<el-empty description="暂无内容" :image-size="100">
									<label class="link_msg" @click="goPublishStore">去发布</label>
								</el-empty>
							</div>
						</div>
					</div> -->
					<div class="flex-column-start sd" style="padding-top: 0px;">
						<div class="sd_head flex-between">
							<el-tabs v-model="sdActiveName" @tab-click="handleAdHeadClick" :stretch="true">
								<el-tab-pane v-for="(recommItem,index) in $t('basic.recommendLebels')" :label="recommItem.value" :name="recommItem.key"></el-tab-pane>
								<!-- <el-tab-pane label="好玩" name="3"></el-tab-pane>
								<el-tab-pane label="好喝" name="1"></el-tab-pane>
								<el-tab-pane label="好吃" name="0"></el-tab-pane> -->
							</el-tabs>
							<div class="mrt_more" @click="goReqsByType('/main/recommendList')" style="position: relative;top: -8px;">
								<div>{{$t('basic.loadmore')}}</div>
								<div class="icon_more"></div>
							</div>
						</div>
						<div v-loading="commendloading" class="hundred commend_conts">
							<div :class="{active:sdActiveName == '0'}" class="cont_body">
								<div v-if="commendReqs0.length > 0" class="comms-warp">
									<div class="comms-item" v-for="(item,index) in commendReqs0" :key="item.sdr_reqId">
										<commendReq :baseUrlpath="baseUrlpath" :item="item"></commendReq>
									</div>
								</div>
								<div v-else class="recomm-empty-msg">
									<el-empty description="暂无内容" :image-size="100">
										<label class="link_msg" @click="goPublishRecomm">去发布</label>
									</el-empty>
								</div>
							</div>
							<div :class="{active:sdActiveName == '1'}" class="cont_body">
								<div v-if="commendReqs1.length > 0" class="comms-warp">
									<div class="comms-item" v-for="(item,index) in commendReqs1" :key="item.sdr_reqId">
										<commendReq :baseUrlpath="baseUrlpath" :item="item"></commendReq>
									</div>
								</div>
								<div v-else class="recomm-empty-msg">
									<el-empty description="暂无内容" :image-size="100">
										<label class="link_msg" @click="goPublishRecomm">去发布</label>
									</el-empty>
								</div>
							</div>
							<div :class="{active:sdActiveName == '2'}" class="cont_body">
								<div v-if="commendReqs2.length > 0" class="comms-warp">
									<div class="comms-item" v-for="(item,index) in commendReqs2" :key="item.sdr_reqId">
										<commendReq :baseUrlpath="baseUrlpath" :item="item"></commendReq>
									</div>
								</div>
								<div v-else class="recomm-empty-msg">
									<el-empty description="暂无内容" :image-size="100">
										<label class="link_msg" @click="goPublishRecomm">去发布</label>
									</el-empty>
								</div>
							</div>
							<div :class="{active:sdActiveName == '3'}" class="cont_body">
								<div v-if="commendReqs3.length > 0" class="comms-warp">
									<div class="comms-item" v-for="(item,index) in commendReqs3" :key="item.sdr_reqId">
										<commendReq :baseUrlpath="baseUrlpath" :item="item"></commendReq>
									</div>
								</div>
								<div v-else class="recomm-empty-msg">
									<el-empty description="暂无内容" :image-size="100">
										<label class="link_msg" @click="goPublishRecomm">去发布</label>
									</el-empty>
								</div>
							</div>
							<div :class="{active:sdActiveName == '4'}" class="cont_body">
								<div v-if="commendReqs4.length > 0" class="comms-warp">
									<div class="comms-item" v-for="(item,index) in commendReqs4" :key="item.sdr_reqId">
										<commendReq :baseUrlpath="baseUrlpath" :item="item"></commendReq>
									</div>
								</div>
								<div v-else class="recomm-empty-msg">
									<el-empty description="暂无内容" :image-size="100">
										<label class="link_msg" @click="goPublishRecomm">去发布</label>
									</el-empty>
								</div>
							</div>
						</div>
					</div>
					<div class="req_Type_echart">
						<NightingaleEcharts></NightingaleEcharts>
					</div>
				</div>
			</div>
		</div>
		<div class="introduce">
			<div class="introduce_body">
				<div class="tit flex-center">
					<svg t="1663501412668" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4507" 
						width="36" height="36"><path d="M768.554667 824.490667v64H258.666667v-64h509.888zM906.666667 181.333333v533.333334h-789.333334v-533.333334h789.333334z m-64 64h-661.333334v405.333334h661.333334v-405.333334z m-432.384 74.453334l45.269333 45.226666-82.986667 82.986667 82.986667 82.986667-45.269333 45.226666-128.213334-128.213333 128.213334-128.213333z m203.434666 0l128.213334 128.213333-128.213334 128.213333-45.269333-45.226666 82.986667-82.986667-82.986667-82.986667 45.269333-45.226666z" fill="#c88854" p-id="4508"></path></svg>
					<label>服务与支持</label>
				</div>
				<div class="ys-desc-warp">
					<div class="ys_itm_warp">
						<div class="intro_itm">
							<div class="intro_wallet"></div>
							<div class="intro_itm_right">
								<div class="intro_item_tit">在线支付、提现</div>
								<div class="quota_msg">平台支持微信、支付宝、云闪付等第三方人民币在线支付，不管你在迪拜还是伊斯坦布尔，轻轻一扫即可立即与卖家交易</div>
							</div>
						</div>
						<div class="intro_itm">
							<div class="intro_db"></div>
							<div class="intro_itm_right">
								<div class="intro_item_tit">安全保障</div>
								<div class="quota_msg">发布物流带货、闲置物品交易等功能，平台提供实名认证以及担保金，多一分担保，多一分安全与安心</div>
							</div>
						</div>
						<div class="intro_itm">
							<div class="intro_jy"></div>
							<div class="intro_itm_right">
								<div class="intro_item_tit">在线交友</div>
								<div class="quota_msg">都在异乡生活工作，中东华人宝有意促进你们的了解与接触，发布一个需求，填写你的基本信息，交友就在弹指间</div>
							</div>
						</div>
					</div>
				</div>
				<div class="tit flex-center">
					<svg t="1663843208442" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2561" width="36" height="36"><path d="M765.952 498.688c-4.608-5.632-11.264-8.704-17.92-8.704-12.288 0-22.528 10.752-25.088 25.088-17.92 113.664-106.496 196.096-210.432 196.096S320 628.736 302.08 515.072c-2.048-14.336-12.8-25.088-25.088-25.088-6.656 0-12.8 3.072-17.92 8.704-6.144 7.168-8.704 17.408-7.168 27.136 22.528 139.264 132.096 240.64 260.096 240.64s237.568-101.376 260.096-240.64c2.56-9.728 0-19.968-6.144-27.136z" fill="#c88854" p-id="2562"></path><path d="M825.856 199.168c-82.944-82.944-195.584-130.048-312.832-129.536-117.248 0-229.888 46.592-312.832 129.536A440.9344 440.9344 0 0 0 70.144 512c0 117.248 46.592 229.888 129.536 312.832 82.944 82.944 195.584 130.048 312.832 129.536 117.248 0 229.888-46.592 312.832-129.536 82.944-82.944 130.048-195.584 129.536-312.832 1.024-117.248-45.568-229.888-129.024-312.832z m-38.912 586.752c-73.216 73.216-170.496 113.664-273.92 113.664-102.912 0.512-201.216-40.448-273.92-113.664-73.216-73.216-113.664-170.496-113.664-273.92-0.512-102.912 40.448-201.216 113.664-273.92C312.32 164.864 409.6 124.416 513.024 124.416c102.912-0.512 201.216 40.448 273.92 113.664 73.216 73.216 113.664 170.496 113.664 273.92 0 102.912-40.96 201.728-113.664 273.92z" fill="#c88854" p-id="2563"></path></svg>
					<label>关于FAYANBO</label>
				</div>
				<div>
					<div class="desc">
						“fa-yan-bo”是中文“华人宝”粤语发音，广东珠三角地区一直是中国与世界上其他国家最早最频繁进行文化贸易交流的区域之一，也是中国最早大规模出海的华侨来源地。广府文化开放进取，博爱包容，无数广东华侨早期为新中国的建设贡献了巨大力量，我们创办FAYANBO，立志于打造领先的一站式海外本地华侨生活服务宝典式实用平台。		
					</div>
				</div>
				<div class="desc-warp">
					<div class="intro_itm_warp">
						<div class="intro_itm" @click="goReqsByType('flightcargo')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">共享航班信息，互惠互利，方便海外同胞，实名认证担保，让带货更加放心</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">物流带货</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">你车技那么好，搭个顺风车行不行？爱拼才快乐，拼出顺风路</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">顺风车</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('markdownsale')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">小件变大件，有用的才是最好的，换一换更完美</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">闲置市场</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('tourist')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">这城市的每个角落，都填满了若有所思的生活，身体和心灵，必须有一个在旅行的路上</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">本地旅游</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('houseproperty')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">你好，您有房子（车子）出租吗？你好，您要租房（车）吗？</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">房 && 车</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('delicacy')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">海外华人出门在外，三餐四季，晒美食是对平凡生活的热爱</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">美食资讯</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('roast')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg">商业新思路，致富新方式，寻找属于你的创富之道</label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">商业机会</label>
								<label class="f_quota">]</label>
							</div>
						</div>
						<div class="intro_itm" @click="goReqsByType('tel')">
							<div class="intro_itm_head">
								<label class="quota">“</label>
								<label class="quota_msg"></label>
								<label class="quota">”</label>
							</div>
							<div class="intro_itm_foot">
								<label class="f_quota">[</label>
								<label class="f_quota_msg">本地通讯</label>
								<label class="f_quota">]</label>
							</div>
						</div>
					</div>
				</div>
				<div class="tit flex-center">
					<svg t="1663843495042" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3791" width="36" height="36"><path d="M172.4416 914.0224H83.1488c-4.9152 0-9.0112-3.8912-11.4688-6.9632-7.7824-9.8304-10.24-25.3952-6.7584-39.5264l83.3536-323.3792c3.072-12.0832 10.8544-21.2992 18.0224-21.2992l58.1632 0.4096v-70.0416l-12.0832-7.5776c-52.6336-32.768-84.1728-89.4976-84.1728-151.3472 0-98.304 79.872-178.176 178.176-178.176 14.1312 0 25.6-11.4688 25.6-25.6s-11.4688-25.6-25.6-25.6c-126.5664 0-229.376 103.0144-229.376 229.376 0 69.8368 30.9248 134.3488 84.1728 177.5616-29.0816 2.4576-54.0672 25.6-62.6688 59.392L15.5648 854.6304c-7.5776 29.2864-1.4336 61.44 15.7696 83.7632 13.5168 17.408 31.9488 26.8288 52.0192 26.8288h89.088c14.1312 0 25.6-11.4688 25.6-25.6s-11.4688-25.6-25.6-25.6zM1017.6512 854.6304l-83.3536-323.3792c-8.8064-33.792-33.5872-57.1392-62.6688-59.392 53.248-43.4176 84.1728-107.9296 84.1728-177.5616 0-126.5664-103.0144-229.376-229.376-229.376-14.1312 0-25.6 11.4688-25.6 25.6s11.4688 25.6 25.6 25.6c98.304 0 178.176 79.872 178.176 178.176 0 62.0544-31.5392 118.5792-84.1728 151.3472l-12.0832 7.5776v70.0416l58.1632-0.4096c7.168 0 14.9504 9.0112 18.0224 21.2992l83.3536 323.3792c3.6864 14.1312 1.024 29.696-6.7584 39.5264-2.4576 3.2768-6.5536 6.9632-11.4688 6.9632h-89.088c-14.1312 0-25.6 11.4688-25.6 25.6s11.4688 25.6 25.6 25.6h89.088c20.0704 0 38.5024-9.6256 52.0192-26.8288 17.6128-22.3232 23.552-54.4768 15.9744-83.7632z" p-id="3792" fill="#c88854"></path><path d="M735.0272 523.8784c-9.4208-36.6592-37.0688-61.44-69.0176-62.0544 57.9584-45.6704 91.7504-114.688 91.7504-189.6448 0-133.3248-108.3392-241.664-241.664-241.664S274.432 139.0592 274.432 272.384c0 74.9568 33.792 143.9744 91.7504 189.6448-31.9488 0.6144-59.5968 25.3952-69.0176 62.0544l-88.4736 342.6304c-7.9872 30.72-1.6384 64.1024 16.384 87.4496 13.9264 18.0224 32.9728 27.8528 53.8624 27.8528h474.112c20.6848 0 39.936-9.8304 53.8624-27.8528 18.0224-23.3472 24.3712-56.7296 16.384-87.4496l-88.2688-342.8352z m31.5392 398.7456c-2.8672 3.6864-7.5776 7.9872-13.312 7.9872H279.1424c-5.9392 0-10.4448-4.3008-13.312-7.9872-8.3968-10.8544-11.264-27.8528-7.3728-43.2128l88.4736-342.6304c3.4816-13.7216 12.288-23.7568 20.6848-23.552l60.2112 0.4096v-71.8848L415.744 434.176c-56.32-35.0208-89.9072-95.4368-89.9072-161.792 0-105.0624 85.4016-190.464 190.464-190.464s190.464 85.4016 190.464 190.464c0 66.1504-33.5872 126.7712-89.9072 161.792l-12.0832 7.5776v71.8848l60.2112-0.4096c8.3968 0 17.2032 9.8304 20.6848 23.552L774.144 879.4112c3.6864 15.36 0.8192 32.3584-7.5776 43.2128z" p-id="3793" fill="#c88854"></path><path d="M646.144 344.8832c10.0352-10.0352 10.0352-26.2144 0-36.2496-10.0352-10.0352-26.2144-10.0352-36.2496 0-25.1904 25.1904-58.7776 39.1168-94.4128 39.1168-35.6352 0-69.2224-13.9264-94.4128-39.1168-10.0352-10.0352-26.2144-10.0352-36.2496 0-10.0352 10.0352-10.0352 26.2144 0 36.2496 34.816 34.816 81.3056 54.0672 130.4576 54.0672 49.5616 0 96.0512-19.0464 130.8672-54.0672zM551.3216 570.5728c0-20.48-16.384-37.0688-36.6592-37.0688-20.2752 0-36.6592 16.5888-36.6592 37.0688 0 17.6128 12.0832 32.3584 28.4672 36.2496l-46.8992 81.1008 55.0912 95.6416 55.0912-95.6416-46.8992-81.1008c16.384-4.096 28.4672-18.8416 28.4672-36.2496z" p-id="3794" fill="#c88854"></path></svg>
					<label>FAYANBO团队</label>
				</div>
				<div class="our_team_warp">
					<div class="desc">
						中东华人宝是中东地区一站式生活服务类平台，团队生活于海湾六国多年，一直深感当地华人社群苦于传统的信息传播模式，因语言障碍不能高效的解决生活基础需求，因此决定开发此平台服务于华人社区。平台提供信息发布，广告发布，闲置商品交易，旅游资讯等服务，平台的宗旨为更好的服务中东地区的华人生活，促进中东地区华人与祖国的情感联系与文化交流传播。中东华人宝团队全部生活在中东地区，对本地文化习俗有着深刻的体会与理解，于华人社区的生长休戚与共，平台坚持以服务社会为成长目标，争做领先的一站式海外华人生活服务类平台。
					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import {
		mapGetters,
		mapActions
	} from 'vuex'
	import reqInfo from '@/components/reqInfo.vue'
	import commendReq from '@/components/commendReq.vue'
	import storeCommendReq from '@/components/storeCommendReq.vue'
	import NightingaleEcharts from '@/components/echarts/NightingaleEcharts.vue'
	export default {
		name:'中东华人宝-首页',
		metaInfo:{
			title:'中东华人宝-首页',
			meta:[
				{
					name: 'keyWords',
					content:'中东华人宝'
				},
				{
					name:'description',
					content:'中东华人宝是中东地区一站式生活服务类平台，团队生活于海湾六国多年，一直深感当地华人社群苦于传统的信息传播模式，因语言障碍不能高效的解决生活基础需求，因此决定开发此平台服务于华人社区。平台提供信息发布，广告发布，闲置商品交易，旅游资讯等服务，平台的宗旨为更好的服务中东地区的华人生活，促进中东地区华人与祖国的情感联系与文化交流传播。中东华人宝团队全部生活在中东地区，对本地文化习俗有着深刻的体会与理解，于华人社区的生长休戚与共，平台坚持以服务社会为成长目标，争做领先的一站式海外华人生活服务类平台'
				}
			]
		},
		components: {
			reqInfo,
			commendReq,
			NightingaleEcharts,
			storeCommendReq
		},
		data() {
			return {
				isCollapse: false,
				currentPage1: 1,
				tableDataHb: [],
				tableDataXz: [],
				tableDataSfc: [],
				tableDataLy: [],
				tableDataInvite: [],
				tableDataFang: [],
				tableDataCar: [],
				tableDatadiscounts:[],
				tableDatadelicacy:[],
				tableDatainteract:[],
				tableDataactivity:[],
				tableDataroast:[],
				tableDatatel:[],
				mainAds: [],
				total: 0,
				pageSize: 3,
				baseUrlpath: '',
				commendReqs0: [],
				commendReqs1: [],
				commendReqs2: [],
				commendReqs3: [],
				commendReqs4: [],
				videoElements:[],
				storeCommendReqs: [],
				sdActiveName: '0',
				commendloading: false,
				storeCommendloading: false,
				tableDatatelLoading: false,
				tableDataroastLoading: false,
				tableDataactivityLoading: false,
				tableDataHbLoading: false,
				tableDataXzLoading: false,
				tableDataSfcLoading: false,
				tableDataLyLoading: false,
				tableDataInviteLoading: false,
				tableDataFangLoading: false,
				tableDataCarLoading: false,
				tableDatadiscountsLoading: false,
				tableDatadelicacyLoading: false,
				tableDatainteractLoading: false,
				commendCurIndex:'',
				commendInterVal:'',
				inchina:''
			};
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			this.inchina = localStorage.getItem('inChina');
			if(this.inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
			// console.log('main==>created')
			this.queryHb();
			this.queryXz();
			this.querySfc();
			this.queryLy();
			this.queryInvite();
			this.queryFang();
			this.queryCar();
			this.queryinteract();
			this.querydelicacy();
			this.querydiscounts();
			this.queryactivity();
			this.queryroast();
			this.querytel();
			this.queryMainAd();
			this.queryCommends();
			//this.getStoreRecommens()
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		updated() {
			this.videoElements = document.getElementsByTagName('video');
			console.log('页面的video数量====>'+this.videoElements.length)
		},
		methods: {
			handleAdHeadClick(tab, event) {
				// console.log(tab.name);
				//this.queryCommends(tab.name);
			},
			async querytel(){
				this.tableDatatelLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '15';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDatatel = res.reqList;
					vm.tableDatatelLoading = false;
				});
			},
			async queryroast(){
				this.tableDataroastLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '14';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataroast = res.reqList;
					vm.tableDataroastLoading = false;
				});
			},
			async queryactivity() {
				this.tableDataactivityLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '5';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataactivity = res.reqList;
					vm.tableDataactivityLoading = false;
				});
			},
			async queryHb() {
				this.tableDataHbLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '1';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataHb = res.reqList;
					vm.tableDataHbLoading = false
				});
			},
			async queryXz() {
				this.tableDataXzLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '4';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataXz = res.reqList;
					vm.tableDataXzLoading  = false;
				});
			},
			async querySfc() {
				this.tableDataSfcLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '2';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataSfc = res.reqList;
					vm.tableDataSfcLoading  = false;
				});
			},
			async queryLy() {
				this.tableDataLyLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '10';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataLy = res.reqList;
					vm.tableDataLyLoading = false
				});
			},
			async queryInvite() {
				this.tableDataInviteLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '3';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataInvite = res.reqList;
					vm.tableDataInviteLoading = false
				});
			},
			async queryFang() {
				this.tableDataFangLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '11';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataFang = res.reqList;
					vm.tableDataFangLoading = false
				});
			},
			async queryCar() {
				this.tableDataCarLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '9';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDataCar = res.reqList;
					vm.tableDataCarLoading = false;
				});
			},
			async querydiscounts() {
				this.tableDatadiscountsLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '7';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDatadiscounts = res.reqList;
					vm.tableDatadiscountsLoading = false;
				});
			},
			async querydelicacy() {
				this.tableDatadelicacyLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '12';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDatadelicacy = res.reqList;
					vm.tableDatadelicacyLoading = false;
				});
			},
			async queryinteract() {
				this.tableDatainteractLoading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				params.areaId = "['all','all']";
				params.reqType = '13';
				var requestUrl = '/apis/getReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.tableDatainteract = res.reqList;
					vm.tableDatainteractLoading = false;
				});
			},
			async queryMainAd() {
				var vm = this;
				var params = {};
				params.adLunchType = "1";
				params.reqType = '0';
				queryUrl("/apis/queryAds", params).then(res => {
					vm.mainAds = res.reList;
				});
			},
			queryCommends() {
				var that = this;
				this.commendloading = true
				var vm = this;
				var params = {};
				params.currentPage = 1;
				params.pageSize = 6;
				params.type = '0';
				var requestUrl = '/apis/getRecommendReqs'
				if(this.inchina == '1'){
					requestUrl = '/cnapis/getRecommendReqs'
				}
				queryUrl(requestUrl, params).then(res => {
					vm.commendReqs0 = res.reqList;
					vm.commendloading = false
					clearInterval(that.commendInterVal)
					that.commendInterVal = setInterval(function(){
						if(that.sdActiveName >= '4'){
							that.sdActiveName = '0'
						}else{
							that.sdActiveName = parseInt(that.sdActiveName) + 1 + ''
						}
					},4000) 
				});
				params.type = '1';
				queryUrl(requestUrl, params).then(res => {
					vm.commendReqs1 = res.reqList;
				});
				params.type = '2';
				queryUrl(requestUrl, params).then(res => {
					vm.commendReqs2 = res.reqList;
				});
				params.type = '3';
				queryUrl(requestUrl, params).then(res => {
					vm.commendReqs3 = res.reqList;
				});
				params.type = '4';
				queryUrl(requestUrl, params).then(res => {
					vm.commendReqs4 = res.reqList;
				});
			},
			getStoreRecommens(type) {
				this.storeCommendloading = true
				var vm = this;
				var params = {};
				params.currentPage = 1;
				params.pageSize = 2;
				params.ssrStt = '0';
				queryUrl("/apis/getStoreRecommens", params).then(res => {
					vm.storeCommendReqs = res.reqList;
					vm.storeCommendloading = false
				});
			},
			changeCollapse() {
				this.isCollapse = !this.isCollapse
			},
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			goToDetail(itemInfo) {
				this.$router.push({
					name: 'reqDetail',
					query: {
						reqNo: itemInfo.sdr_reqId
					}
				});
			},
			goPublish(){
				this.$router.push({
					name: 'publishIndex'
				});
			},
			goPublishRecomm(){
				this.$router.push({
					name: '/recommend/publish'
				});
			},
			goPublishStore(){
				this.$router.push({
					name: '/storeRecommend/publish'
				});
			},
			goReqsByType(reqType) {
				this.$router.push({
					name: reqType,
				});
			},
			pushadvertise(){
				if (!this.userInfo.fayanboId) {
					this.$util.warnMsg("请登录系统！")
					this.$store.dispatch('setLoginDialogvisible', true)
				} else {
					this.$router.push({
						name: '/my/advertisements'
					});
				}
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	
	.ys-desc-warp {
		.ys_itm_warp {
			display: flex;
			.intro_wallet {
				background: url(../assets/icon/main_zhifu.png) no-repeat center;
				background-size: 100%;
				width: 44px;
				height: 44px;
			}
			.intro_db {
				background: url(../assets/icon/main_db.png) no-repeat center;
				background-size: 100%;
				width: 44px;
				height: 44px;
			}
			.intro_jy {
				background: url(../assets/icon/main_jy.png) no-repeat center;
				background-size: 100%;
				width: 44px;
				height: 44px;
			}
			.intro_itm {
				color: #666666;
				font-size: 14px;
				padding: 20px 24px;
				border-radius: 8px 8px 8px 8px;
				box-sizing: border-box;
				flex: 1;
				display: flex;
				align-items: center;
				.intro_item_tit {
					color: #333333;
					font-size: 16px;
					font-weight: 500;
					line-height: 20px;
					text-align: left;
				}
				.intro_itm_right {
					flex: 1;
					text-align:left;
					margin-left: 16px;
				}
				.quota_msg {
					margin-top: 12px;
				}
			}
			.intro_itm:first-child {
				margin-left: 0;
				background: linear-gradient(-180deg, #fafcff 0%, #f2f8fe 100%);
			}
			.intro_itm:nth-child(2) {
				background: #fff8f2;
				margin-left: 16px;
			}
			.intro_itm:nth-child(3) {
				background: #f2fbf8;
				margin-left: 16px;
			}
		}
		
	}
	.mindel-h {
		height: 40px;
	}

	.home_left_content {
		//width: 780px;
		//width: calc(100% - 440px);
		/* box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.06); */
		width: calc(70% - 60px);
		background-color: rgb(234 230 230 / 6%);
	}

	.home_right_content {
		position: sticky;
		top: 0;
		//width: 428px;
		width: 30%;
		height: 1180px;
		padding:0px 0px 10px 20px;
		overflow:hidden;
		/* box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.06); */
		.req_Type_echart {
			width: 100%;
			height: 400px;
			padding-top: 10px;
		}
	}

	.home_right_content .sd {
		box-shadow: 0px 4px 16px 1px rgba(0, 0, 0, 0.06);
		padding: 14px 14px 0px 14px;
		margin-bottom: 10px;
		position: relative;
		.sd_head {
			width: 100%;
			background-color: #fbd8b9;
			border-top-left-radius: 8px;
			border-top-right-radius: 8px;
			.el-tabs__item {
				padding: 0 10px
			}
		}
	}

	.recomm-empty-msg {
		height: 711px;
		.link_msg {
			color: #DD6161;
			font-size: 12px;
			cursor: pointer;
			text-decoration:underline
		}
	}

	.home_right_content .news-warp {
		min-height: 180px;
		text-align: left;
		width: 100%;

		.new-item {
			width: 100%;
			line-height: 40px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;

			.new_tit {
				font-size: 14px;
			}

			.new_time {
				font-size: 10px;
				color: #777;
			}
		}

		.new-item:hover {
			color: #C88854;
		}
	}

	.home_right_content .comms-warp {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		flex-wrap: wrap;
		width: 100%;
	}

	.home_right_content .comms-warp .comms-item {
		width: calc((100% - 4px)/2);
		box-sizing: border-box;
		/* height: 170px; */
		overflow: hidden;
	}

	.home_right_content .yjwarp {
		height: 100px;
		background-color: #faf1ea;
		border-radius: 10px;
		padding: 0 10px;
		cursor: pointer;
	}

	.home_right_content .yjwarp .yjmsg {
		display: flex;
		justify-content: space-around;
		align-items: flex-start;
		flex-direction: column;
		height: 70%;
		margin-left: 10px;
	}

	.home_right_content .yjwarp .yjmsg .yj-tit {
		color: #333333;
		font-size: 16px;
		font-weight: 500;
		line-height: 20px;
	}

	.home_right_content .yjwarp .yjmsg .yj-nail {
		color: #666666;
		font-size: 14px;
		font-weight: normal;
		line-height: 20px;
	}

	.home_right_content .rd-title {
		color: #c88854;
		font-size: 18px;
		font-weight: 700;
		line-height: 24px;
		margin-bottom: 10px;
		text-align: left;
		width: 100%;
	}

	.adwarp {
		box-shadow: 0px 4px 16px 1px rgba(0, 0, 0, 0.06);
		background-color: #fff;
		.advertise_bg {
			width: 100%;
			height: 100%;
			position: relative;
			.img {
				width: 100%;
				height: 100%;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.medium {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
			}
		}
	}
	.main_req_warp {
		height: 976px;
		overflow: scroll;
		box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
	}
	.mrt_more {
		color: #777;
		font-size: 13px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		font-weight: 300;
		.icon_more {
			background: url(../assets/icon/more.png) no-repeat center;
			background-size: 100%;
			width: 20px;
			height: 20px;
		}
	}
	.main_req_top {
		width: 100%;
		.empty-msg {
			color: #999999;
			height: 360px;
			.el-empty__bottom {
				margin-top: 4px;
			}
			.link_msg {
				color: #DD6161;
				font-size: 12px;
				cursor: pointer;
				text-decoration:underline
			}
		}
		.mrt_head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;
			.mrt_tit {
				font-size: 18px;
				font-weight: bold;
				color: #C88854;
			}
		}
		.req-warp {
			display: flex;
			flex-wrap: wrap;
			margin-top: 10px;
			.req-item {
				width: calc((100% - 24px) / 3);
				border-radius: 8px;
				box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.06);
				margin-bottom: 12px;
				background-color: #fff;
			}
			.req-item:not(:nth-child(3n)) {
				margin-right: 12px;
			}
		}
	}

	.container {
		position: relative;
		//width: 100%;
		padding: 0 20px;
		margin: 0 auto;
		align-items: flex-start;
	}

	.icon-yijian {
		background: url(../assets/icon/yijian.png) center no-repeat;
		background-size: 100%;
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
	
	.our_team_warp {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		.otw_l {
			width: 30%;
			line-height: 28px;
		}
		.otw_r {
			flex: 1;
		}
	}
	
	.qrcode_warp {
		display: flex;
		justify-content: space-around;
		margin-bottom: 80px;
		margin-top: 20px;

		.gzh_qrcode {
			background: url(../assets/icon/qrcode_for_gh_9696e0cc0088_344.jpg) center no-repeat;
			background-size: 100%;
			width: 200px;
			height: 200px;
			margin-bottom: 20px;
		}

		.xcx_qrcode {
			background: url(../assets/icon/gh_456f22a2f958_344.jpg) center no-repeat;
			background-size: 100%;
			width: 200px;
			height: 200px;
			margin-bottom: 20px;
		}

		.app_qrcode {
			background: url(../assets/icon/JSONS_637976590453355845.png) center no-repeat;
			background-size: 93%;
			width: 200px;
			height: 200px;
			margin-bottom: 20px;
		}
	}

	.introduce {
		.introduce_body {
			width: 90%;
			margin: 0 auto;

			.tit {
				color: #c88854;
				text-align: center;
				font-size: 24px;
				font-weight: bold;
				line-height: 90px;
				label {
					margin-left: 8px;
				}
			}

			.desc-warp {}

			.desc {
				text-align: left;
				padding: 30px 20px;
				letter-spacing: 1px;
				word-break: break-word;
				white-space: break-spaces;
				background: #faf1ea;
				border-radius: 10px;
				color: #676161;
			}

			.intro_itm_warp {
				flex-wrap: wrap;
				display: flex;
				flex: 1;
				margin-top: 20px;

				.intro_itm:hover {
					background-color: #faf1ea;
					transform: scale(1.1);
					transition: transform 0.45s ease;
				}

				.intro_itm {
					width: calc((100% - 80px)/4);
					height: 160px;
					margin-bottom: 20px;
					box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
					border-radius: 10px;
					border: 1px solid #f0f0f5;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					cursor: pointer;

					.intro_itm_head {
						text-align: left;
						padding: 8px 16px;

						.quota {
							font-weight: bold;
							color: #c88854;
						}

						.quota_msg {
							font-size: 14px;
							color: #626467;
							text-align: left;
							padding: 0 4px;
						}
					}

					.intro_itm_foot {
						text-align: right;
						padding-right: 16px;

						.f_quota {
							color: #c88854;
						}

						.f_quota_msg {
							padding: 0 4px;
							font-size: 14px;
						}
					}
				}

				.intro_itm:not(:nth-child(4n)) {
					margin-right: 20px;
				}
			}
		}
	}
</style>
